import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import getEmitter from '/bubble-button/src/postmessage/emitter';
import style from './style.scss'


class ChatBubble extends Component {
    constructor(props){
        super(props)
        this.emitter = getEmitter()

        this.state = {
            openSrc: '/common/assets/images/open.png',
            closeSrc: '/common/assets/images/open.png'
        }

    }

    componentDidMount() {
        var openImg = new Image()
        var closeImg = new Image()
        openImg.onload = () => {
            this.setState({openSrc: openImg})
        }
        openImg.src = '/common/assets/images/open.png';

        closeImg.onload = () => {
            this.setState({closeSrc: closeImg})
        }
        closeImg.src = '/common/assets/images/close.png';
    }

    emitOpenState(isOpen){
        return () => this.emitter.send('*', 'openState', isOpen)

    }
    renderUnreadEntriesCount() {
        const count = this.props.totalUnreadEntries;
        if(count <= 0)
            return null;

        return (
            <span className={style.UnreadEntriesCount}>{count}</span>
        );
    }

    render() {
        const isChatOpen = this.props.chat.get('isOpen', false);
        let color = this.props.customization.get('color');
        if(!this.props.customization || !color){
            return null;
        }

        let tempOpenSrc = this.state.openSrc.src
        //if (this.props.companyId === 7 || this.props.companyId === 1){
        //    tempOpenSrc = '/common/assets/images/ChatBubble_Easter_Open_Inverted.png';
        //}

        let tempCloseSrc = this.state.closeSrc.src
        //if (this.props.companyId === 7 || this.props.companyId === 1){
        //    tempCloseSrc = '/common/assets/images/ChatBubble_Easter_Close_Inverted.png';
        //}
        //
        // let TmpComponent = null;
        // if(this.props.companyId === 7 || this.props.companyId === 1){
        //     TmpComponent = <img
        //                         src='/common/assets/images/XmasChatHat.png'
        //                         className={style.tmpComponent}
        //                     />
        // }
        //
        // let TmpSnow = null;
        // if(this.props.companyId === 7 || this.props.companyId === 1){
        //     TmpSnow = (
        //         <div class='WinterIsComing'>
        //             <div class="snow snow--near"></div>
        //             <div class="snow snow--near snow--alt"></div>
        //
        //             <div class="snow snow--mid"></div>
        //             <div class="snow snow--mid snow--alt"></div>
        //
        //             <div class="snow snow--far"></div>
        //             <div class="snow snow--far snow--alt"></div>
        //         </div>
        //     )
        //  }
        //Don't render anything if images are not loaded.
        if (isChatOpen === true) {
            return (
                <div className={style.ChatBubbleWrapper}
                >
                    {/*TmpComponent*/}
                    {/*TmpSnow*/}
                    <img
                        onClick={this.emitOpenState(false)}
                        className={style.ChatBubbleImage}
                        src={tempCloseSrc} />
                    <div className={style.ChatBubbleBackground} style={{ "background": color}}/>
                </div>
            );
        } else if (isChatOpen === false) {
            return (
                <div className={style.ChatBubbleWrapper}
                >
                    {/*TmpComponent*/}
                    {/*TmpSnow*/}
                    <img
                        onClick={this.emitOpenState(true)}
                        className={style.ChatBubbleImage}
                        src={tempOpenSrc} />
                    <div className={style.ChatBubbleBackground} style={{ "background": color}}/>
                    {this.renderUnreadEntriesCount()}
                </div>
            );
        } else {
            return null;
        }
    }
}

function mapStateToProps(state) {
    return {
        totalUnreadEntries: state.get('totalUnreadEntries', 0),
        customization: state.get('customization'),
        chat: state.get('chat'),
        domain: state.getIn(['visitor', 'domain']),
        companyId: state.getIn(['company', 'id'])
    };
}
export default connect(mapStateToProps)(ChatBubble);



// WEBPACK FOOTER //
// ./components/ChatBubble/index.js